import type { Tile, GridStackTile } from "../../types/tile";
import { groupByTileType } from "./tileGrouper/tileGroupByTileType";
import { groupByColours } from "./tileGrouper/tileGroupByColour";
import { arrangeTilesWithGaps } from "./tileArranger/arrangeWithGaps";

export const sortByColour = (gridStackTiles: GridStackTile[]) => {
    const tiles = gridStackTilesToTiles(gridStackTiles);

    const groupedTiles = groupByColours(tiles);
    const sortedTiles = arrangeTilesWithGaps(groupedTiles);

    return sortedTiles;
};

export const sortByTileType = (gridStackTiles: GridStackTile[]) => {
    const tiles = gridStackTilesToTiles(gridStackTiles);

    const groupedTiles = groupByTileType(tiles);
    const sortedTiles = arrangeTilesWithGaps(groupedTiles);

    return sortedTiles;
};

const gridStackTilesToTiles = (gridStackTiles: GridStackTile[]) =>
    gridStackTiles.map<Tile>((trayTile) => ({
        Colour: trayTile.colour,
        TileType: trayTile.tileType,
    }));
